import React from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";

export const BrowserSessionModal = ({
    visible,
    onClose,
    onSave,
    handleConfirmPassword,
    confirmPassword,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            isOpen={visible}
            onRequestClose={onClose}
            closeTimeoutMS={200}
            shouldCloseOnOverlayClick={true}
            ariaHideApp={false}
            className="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:w-full sm:max-w-2xl sm:mx-auto"
            style={{
                overlay: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(107, 114, 128, 0.75)",
                },
            }}
        >
            <form onSubmit={(e)=>onSave(e)}>
                <div className="px-12 pt-10 ">
                    <div className="font-bold text-xl">
                        {t("Log Out Other Browser Sessions")}
                    </div>
                    <p className="col-span-3 sm:col-span-3 py-3.5 text-xs text-gray-600">
                        {t(
                            "Please enter your password to confirm you would like to log out of your other browser sessions across all of your devices."
                        )}
                    </p>

                    <div className="bg-white">
                        <div className="col-span-3 sm:col-span-3 py-3.5">
                            <input
                                type="password"
                                placeholder={t("Password")}
                                name="password"
                                onChange={handleConfirmPassword}
                                value={confirmPassword}
                                className="font-bold text-black mt-1 mb-9 border-none focus:ring-purple-300 focus:bg-purple-50 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                            />
                        </div>
                    </div>
                </div>

                <div className="py-5 px-12 text-right">
                    <button
                        type="button"
                        className="inline-flex justify-center mr-2 py-2 px-7 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-300 hover:bg-gray-400 activ:bg-gray-500 focus:outline-none"
                        onClick={onClose}
                    >
                        {t("Cancel")}
                    </button>
                    <button                        
                        type="submit"
                        className="inline-flex justify-center py-2 px-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                    >
                        {t("Log out from browser sessions")}
                    </button>
                </div>
            </form>
        </Modal>
    );
};
